import { jsx as _jsx } from "react/jsx-runtime";
import { AvatarContainer, CustomImg } from './styles';
export const DEFAULT_AVATAR_SIZE = 5.4;
const Avatar = ({ imageUrl, firstName, testId = 'avatar', size = DEFAULT_AVATAR_SIZE, className, imgTestId,
// onClick,
 }) => {
    // const handleClick = () => {
    //   if (onClick) onClick();
    // };
    return (_jsx(AvatarContainer, { "data-cy": testId, "data-testid": testId, size: size, imageUrl: imageUrl, className: className, children: imageUrl ? (_jsx(CustomImg, { src: imageUrl, "data-testid": imgTestId })) : (firstName?.[0]?.toUpperCase()) }));
};
export default Avatar;
//# sourceMappingURL=Avatar.js.map